

import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import aboutbanner from "../assets/aboutbanner.jpg";
import PosterOne from "../share/component.jsx/posterone";
import BannerOne from "../share/component.jsx/banner";


const SERVICES = [
  {
    id: 1,
    image: require('../assets/services/Coronary Angioplasty & Stenting.jpg'),
    title: "Coronary Angioplasty & Stenting",
    desc: "Coronary angioplasty and stenting are used to restore healthy blood flow to the heart with blocked or narrowed coronary arteries. The procedure involves opening the artery with a small balloon and maintaining the artery with a drug-eluting stent.",
    fullDesc: "Coronary angioplasty and stenting are used to restore healthy blood flow to the heart with blocked or narrowed coronary arteries. The procedure involves opening the artery with a small balloon and maintaining the artery with a drug-eluting stent.\n\nThis is a minimally invasive intervention that could potentially alleviate chest pain, improve blood flow to the heart, and lower the risk of severe cardiac events. Thus, it frequently proves to be a reliable alternative for patients with coronary artery disease."
  },
  {
    id: 2,
    image: require('../assets/services/Coronary Angiography.jpg'),
    title: "Coronary Angiography",
    desc: "High-resolution X-ray imaging with contrast dye provides a clear view of the coronary arteries. It assists physicians in locating obstructions, constriction, or other issues with the arteries with great precision.",
    fullDesc: "Coronary angiography involves high-resolution X-ray and contrast dye to obtain a clear view of the coronary arteries. It assists physicians in locating obstructions, constriction, or other issues along the arteries with great precision.\n\nSince the test provides detailed images, it facilitates planning of treatments. Consequently, patients will be able to obtain the correct care at the right moment, whether they require medication, angioplasty, stenting, or additional cardiac assistance."
  },
  {
    id: 3,
    image: require('../assets/services/Cardiac Catheterization.jpg'),
    title: "Cardiac Catheterization",
    desc: "An innovative diagnostic method to evaluate the state of the heart, blood circulation, the level of pressure, and the condition of the valves. Physicians place a slender tube into a blood vessel and guide it to the heart.",
    fullDesc: "Cardiac catheterization is an innovative diagnostic method to evaluate the state of the heart, blood circulation, the level of pressure, and the condition of the valves. Physicians put a slender tube into a blood vessel and lead it to the heart.\n\nThe process is beneficial in diagnosing coronary disease, valve disease, and other diseases of the heart. In addition, it provides physicians with valuable information prior to deciding on any advanced therapy or minimally invasive heart surgeries."
  },
  {
    id: 4,
    image: require('../assets/services/IVUS & OCT Imaging.jpg'),
    title: "IVUS & OCT Imaging",
    desc: "IVUS and OCT imaging produce detailed images of the interior parts of the arteries. IVUS works with ultrasound, and OCT works with light-based imaging to study the walls of the arteries, plaque formation, and the presence of stents.",
    fullDesc: "IVUS and OCT imaging pictures are detailed images of the interior parts of the arteries. IVUS works with ultrasound, and OCT works with light-based imaging to study the walls of the arteries, plaque formation, and the presence of stents.\n\nThese new technologies assist physicians in selecting the appropriate stent size and properly placing it. Thus, they enhance procedural precision and help to achieve improved long-term outcomes of patients undergoing coronary intervention."
  },
  {
    id: 5,
    image: require('../assets/services/Structural Heart Interventions.jpg'),
    title: "Structural Heart Interventions",
    desc: "Valve defects and defects in the structure of the heart are treated using structural heart procedures that do not require open-heart surgery. Such procedures involve TAVR, MitraClip, and ASD or PFO closure.",
    fullDesc: "Valve defects and defects in the structure of the heart are treated using structural heart procedures that do not require open-heart surgery. Such procedures might involve TAVR, MitraClip, and ASD or PFO closure.\n\nDue to the fact that these methods involve a technology that uses catheters, many patients have a short stay in the hospital and recover faster. They will particularly be useful to individuals who might be at a greater risk in conventional surgery."
  },
  {
    id: 6,
    image: require('../assets/services/Peripheral Vascular Interventions.jpg'),
    title: "Peripheral Vascular Interventions",
    desc: "Peripheral vascular interventions are used to treat blocked or constricted arteries of the body outside the heart, including peripheral artery disease, renal artery stenosis, and carotid artery constriction.",
    fullDesc: "The peripheral vascular interventions are used to treat blocked or constricted arteries of the body outside the heart. These can be peripheral artery disease, renal artery stenosis, and carotid artery constriction.\n\nBy treating with catheters, doctors can enhance blood flow, decrease symptoms, and assist in the protection of vital organs. Consequently, patients can have enhanced mobility, increased circulation, and enhanced overall vascular health."
  },
];

const STATS = [
  { value: "25+", label: "Years Experience" },
  { value: "40K+", label: "Procedures Performed" },
  { value: "98.7%", label: "Success Rate" },
  { value: "#1", label: "Ranked in USA" },
];

const WHY = [
  { 
    image: require('../assets/services/Among the Top Cardiologists in the World.jpg'),
    title: "Among the Top Cardiologists in the World", 
    desc: "The cardiac care team provides advanced training, international experience, and good procedural experience to each patient case. Our areas of concern are accurate diagnosis, safe intervention, and long-term heart wellness. Our evidence-based care and advanced technology will allow patients to place their trust in our services." 
  },
  { 
    image: require('../assets/services/World-Recognized Expertise.jpg'),
    title: "World-Recognized Expertise", 
    desc: "Our professionals are familiar with advanced coronary, structural, and vascular procedures. Their work demonstrates international standards of cardiac care, clinical decision-making, and patient safety. With a strong reputation for excellence, our team continues to deliver care inspired by the world's top cardiologist community." 
  },
  { 
    image: require('../assets/services/Patient-First Approach.jpg'),
    title: "Patient-First Approach", 
    desc: "Each patient is provided with a unique treatment program. We listen attentively, clarify all options to patients, and lead them honestly and with care. We emphasize comfort, safety, and confidence in the treatment process." 
  },
  { 
    image: require('../assets/services/Cutting-Edge Technology.jpg'),
    title: "Cutting-Edge Technology", 
    desc: "We apply a high-tech catheterization lab, AI-assisted imaging, intravascular equipment, and up-to-date procedural systems. Since heart care requires precision, our technology helps to make faster decisions, safer procedures, and more effective treatment results." 
  },

];

/* ─── PULSE LINE SVG ────────────────────────────────── */
const PulseLine = ({ color = "#2acb35", width = 120, height = 32 }) => (
  <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} fill="none">
    <polyline
      points={`0,${height / 2} ${width * 0.2},${height / 2} ${width * 0.3},4 ${width * 0.4},${height - 4} ${width * 0.5},4 ${width * 0.6},${height - 4} ${width * 0.7},${height / 2} ${width},${height / 2}`}
      stroke={color}
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);


const Counter = ({ value }) => {
  const [display, setDisplay] = useState("0");
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const numeric = parseFloat(value.replace(/[^0-9.]/g, ""));
          const suffix = value.replace(/[0-9.]/g, "");
          let start = 0;
          const step = numeric / 40;
          const timer = setInterval(() => {
            start += step;
            if (start >= numeric) {
              setDisplay(value);
              clearInterval(timer);
            } else {
              setDisplay(Math.floor(start) + suffix);
            }
          }, 30);
          observer.disconnect();
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value]);
  return <span ref={ref}>{display}</span>;
};

/* ─── SERVICE CARD ──────────────────────────────────── */
const ServiceCard = ({ s, i }) => {
  const [hov, setHov] = useState(false);
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <div
        onClick={() => setExpanded(!expanded)}
        onMouseEnter={() => setHov(true)}
        onMouseLeave={() => setHov(false)}
        style={{
          // background: hov
          //   ? "linear-gradient(135deg, #2acb35 0%, #4dde70 100%)"
          //   : "#ffffff",
            background: "#ffffff",
          borderRadius: 20,
          padding: "32px 28px",
          boxShadow: hov
            ? "0 24px 60px rgba(42,203,53,0.35)"
            : "0 4px 24px rgba(0,0,0,0.07)",
          transform: hov ? "translateY(-8px) scale(1.02)" : "translateY(0) scale(1)",
          transition: "all 0.35s cubic-bezier(.22,.68,0,1.2)",
          cursor: "pointer",
          border: hov ? "1.5px solid transparent" : "1.5px solid #f1f5f9",
          animationDelay: `${i * 0.1}s`,
        }}
      >
        <div style={{ width: 70, height: 70, borderRadius: 14,  display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", transition: "background 0.3s", marginBottom: 15 }}>
          {s.image ? (
            <img src={s.image} alt={s.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <span style={{ fontSize: 24 }}>{s.icon}</span>
          )}
        </div>
        <h3
          style={{
            margin: "0 0 12px",
            fontSize: 17,
            fontWeight: 700,
            color: "#0f172a",
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            letterSpacing: "-0.01em",
            lineHeight: 1.3,
          }}
        >
          {s.title}
        </h3>
        <p
          style={{
            margin: "0 0 16px",
            fontSize: 13.5,
            lineHeight: 1.75,
            color:  "#64748b",
            fontFamily: "'Lora', Georgia, serif",
          }}
        >
          {s.desc}
        </p>
        <button
          style={{
            background: "transparent",
            color:  "#2acb35",
            border:  "1.5px solid #2acb35",
            padding: "8px 16px",
            borderRadius: "6px",
            fontSize: "12px",
            fontWeight: 600,
            cursor: "pointer",
            transition: "all 0.3s ease",
            fontFamily: "'Hind', sans-serif",
          }}
          onMouseEnter={(e) => {
            e.target.style.background =  "#2acb35";
            e.target.style.color =  "#fff";
          }}
          onMouseLeave={(e) => {
            e.target.style.background = "transparent";
            e.target.style.color =  "#2acb35";
          }}
        >
          {expanded ? "Show Less" : "Read More"}
        </button>
      </div>

      {/* Expanded Detail Section */}
      {expanded && (
        <div
          style={{
            background: "#fff",
            borderRadius: "16px",
            padding: "28px",
            marginTop: "16px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            gridColumn: "1 / -1",
            animation: "slideDown 0.3s ease",
            border: "1.5px solid #f1f5f9",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "20px",
              color: "#2acb35",
            }}
          >
            <div style={{ width: 4, height: 24, background: "#2acb35", borderRadius: "2px" }} />
            <h3 style={{ margin: 0, fontSize: "22px", fontWeight: 700, fontFamily: "'Cormorant Garamond', Georgia, serif", color: "#0f172a" }}>
              {s.title}
            </h3>
          </div>
          <p
            style={{
              whiteSpace: "pre-wrap",
              fontSize: "15px",
              lineHeight: 1.8,
              color: "#475569",
              fontFamily: "'Lora', Georgia, serif",
              margin: 0,
            }}
          >
            {s.fullDesc}
          </p>
        </div>
      )}
    </>
  );
};

/* ─── MAIN COMPONENT ────────────────────────────────── */
export default function InterventionalCardiology() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <style>{`
        
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-12px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .cardo-root {
          font-family: 'Hind', sans-serif;
          background: #fff;
          color: #0f172a;
          min-height: 100vh;
        }

        /* NAV */
        .cardo-nav {
          position: sticky;
          top: 0;
          z-index: 100;
          background: rgba(255,255,255,0.95);
          backdrop-filter: blur(12px);
          border-bottom: 1px solid #f1f5f9;
          padding: 0 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 68px;
        }
        .cardo-logo {
          display: flex;
          align-items: center;
          gap: 10px;
          text-decoration: none;
        }
        .cardo-logo-icon {
          width: 38px; height: 38px;
          background: linear-gradient(135deg, #2acb35, #4dde70);
          border-radius: 10px;
          display: flex; align-items: center; justify-content: center;
          font-size: 20px;
        }
        .cardo-logo-text {
          font-family: 'Cormorant Garamond', serif;
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
          letter-spacing: -0.02em;
        }
        .cardo-logo-text span { color: #2acb35; }
        .cardo-nav-links {
          display: flex;
          gap: 32px;
          list-style: none;
        }
        .cardo-nav-links a {
          text-decoration: none;
          font-size: 14px;
          font-weight: 500;
          color: #475569;
          transition: color 0.2s;
        }
        .cardo-nav-links a:hover { color: #2acb35; }
        .cardo-nav-cta {
          background: linear-gradient(135deg, #2acb35, #4dde70);
          color: #fff;
          border: none;
          padding: 10px 22px;
          border-radius: 30px;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          letter-spacing: 0.04em;
          transition: opacity 0.2s, transform 0.2s;
          font-family: 'Hind', sans-serif;
        }
        .cardo-nav-cta:hover { opacity: 0.9; transform: translateY(-1px); }
        .cardo-hamburger {
          display: none;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #0f172a;
        }

        /* HERO */
        .cardo-hero {
          background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 60%, #3b0764 100%);
          position: relative;
          overflow: hidden;
          padding: 100px 40px 80px;
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 88vh;
        }
        .cardo-hero-bg {
          position: absolute;
          inset: 0;
          background:
            radial-gradient(ellipse 60% 60% at 80% 50%, rgba(42,203,53,0.18) 0%, transparent 70%),
            radial-gradient(ellipse 40% 40% at 15% 70%, rgba(99,102,241,0.12) 0%, transparent 60%);
          pointer-events: none;
        }
        .cardo-hero-grid-lines {
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
          background-size: 48px 48px;
          pointer-events: none;
        }
        .cardo-hero-content {
          position: relative;
          z-index: 2;
          max-width: 900px;
          text-align: center;
        }
        .cardo-hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: rgba(42,203,53,0.18);
          border: 1px solid rgba(42,203,53,0.4);
          color: #65c772;
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          padding: 6px 16px;
          border-radius: 30px;
          margin-bottom: 28px;
        }
        .cardo-hero-badge::before { content: '●'; color: #2acb35; font-size: 8px; }
        .cardo-hero-h1 {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: clamp(38px, 6vw, 76px);
          font-weight: 700;
          color: #fff;
          line-height: 1.1;
          letter-spacing: -0.02em;
          margin-bottom: 24px;
        }
        .cardo-hero-h1 em {
          font-style: italic;
          background: linear-gradient(90deg, #6fdd8a, #2acb35);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        .cardo-hero-sub {
          font-size: clamp(15px, 2vw, 18px);
          color: rgba(255,255,255,0.7);
          max-width: 620px;
          margin: 0 auto 40px;
          line-height: 1.75;
          font-family: 'Lora', serif;
        }
        .cardo-hero-btns {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .btn-primary {
          background: linear-gradient(135deg, #2acb35, #4dde70);
          color: #fff;
          border: none;
          padding: 15px 34px;
          border-radius: 40px;
          font-size: 14px;
          font-weight: 700;
          cursor: pointer;
          letter-spacing: 0.05em;
          transition: all 0.25s;
          font-family: 'Hind', sans-serif;
          box-shadow: 0 8px 24px rgba(42,203,53,0.4);
        }
        .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 32px rgba(42,203,53,0.5); }
        .btn-outline {
          background: rgba(255,255,255,0.08);
          color: #fff;
          border: 1.5px solid rgba(255,255,255,0.25);
          padding: 15px 34px;
          border-radius: 40px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          letter-spacing: 0.04em;
          transition: all 0.25s;
          font-family: 'Hind', sans-serif;
          backdrop-filter: blur(4px);
        }
        .btn-outline:hover { background: rgba(255,255,255,0.15); border-color: rgba(255,255,255,0.45); }

        /* STATS BAR */
        .cardo-stats {
          background: linear-gradient(135deg, #123b21 0%, #1a5a2f 100%);
          padding: 36px 40px;
          display: flex;
          justify-content: center;
          gap: 0;
          flex-wrap: wrap;
        }
        .cardo-stat {
          flex: 1;
          min-width: 140px;
          text-align: center;
          padding: 12px 20px;
          position: relative;
        }
        .cardo-stat:not(:last-child)::after {
          content: '';
          position: absolute;
          right: 0; top: 20%; height: 60%;
          width: 1px;
          background: rgba(255,255,255,0.25);
        }
        .cardo-stat-val {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(28px, 4vw, 42px);
          font-weight: 700;
          color: #fff;
          line-height: 1;
          display: block;
        }
        .cardo-stat-lbl {
          font-size: 12px;
          font-weight: 600;
          color: rgba(255,255,255,0.75);
          letter-spacing: 0.08em;
          text-transform: uppercase;
          margin-top: 6px;
          display: block;
        }

        /* SECTIONS */
        .cardo-section {
          padding: 90px 40px;
          max-width: 1240px;
          margin: 0 auto;
        }
        .cardo-section-label {
          font-size: 11px;
          font-weight: 700;
          color: #2acb35;
          letter-spacing: 0.18em;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
        .cardo-section-h2 {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: clamp(28px, 4vw, 48px);
          font-weight: 700;
          color: #0f172a;
          line-height: 1.15;
          letter-spacing: -0.02em;
          margin-bottom: 16px;
        }
        .cardo-section-desc {
          font-size: 16px;
          color: #64748b;
          max-width: 560px;
          line-height: 1.75;
          font-family: 'Lora', serif;
          margin-bottom: 56px;
        }
        .cardo-services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }

        /* WHY SECTION */
        .cardo-why {
          background: #f8fafc;
          padding: 90px 40px;
        }
        .cardo-why-inner {
          max-width: 1240px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }
        .cardo-why-cards {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
        }
        .cardo-why-card {
          background: #fff;
          border-radius: 16px;
          padding: 24px;
          border: 1.5px solid #f1f5f9;
          transition: border-color 0.25s, box-shadow 0.25s;
        }
        .cardo-why-card:hover {
          border-color: rgba(42,203,53,0.3);
          box-shadow: 0 8px 32px rgba(42,203,53,0.1);
        }
        .cardo-why-card-icon {
          font-size: 28px;
          margin-bottom: 12px;
          display: block;
        }
        .cardo-why-card h4 {
          font-family: 'Cormorant Garamond', serif;
          font-size: 17px;
          font-weight: 700;
          color: #0f172a;
          margin-bottom: 8px;
        }
        .cardo-why-card p {
          font-size: 13px;
          color: #64748b;
          line-height: 1.7;
          font-family: 'Lora', serif;
        }

        /* CTA */
        .cardo-cta {
          background: linear-gradient(135deg, #0f2d1a 0%, #192f1e 100%);
          padding: 90px 40px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .cardo-cta::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(ellipse 50% 80% at 50% 100%, rgba(42,203,53,0.2) 0%, transparent 70%);
          pointer-events: none;
        }
        .cardo-cta h2 {
          font-family: 'Cormorant Garamond', serif;
          font-size: clamp(28px, 4vw, 52px);
          font-weight: 700;
          color: #fff;
          letter-spacing: -0.02em;
          margin-bottom: 16px;
          position: relative;
        }
        .cardo-cta p {
          font-size: 16px;
          color: rgba(255,255,255,0.65);
          max-width: 500px;
          margin: 0 auto 36px;
          font-family: 'Lora', serif;
          line-height: 1.7;
          position: relative;
        }

        /* FOOTER */
        .cardo-footer {
          background: #0f172a;
          border-top: 1px solid rgba(255,255,255,0.06);
          padding: 24px 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 12px;
        }
        .cardo-footer p {
          font-size: 13px;
          color: rgba(255,255,255,0.4);
        }
        .cardo-footer-kw {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        .cardo-footer-kw span {
          font-size: 11px;
          color: rgba(42,203,53,0.8);
          background: rgba(42,203,53,0.1);
          padding: 3px 10px;
          border-radius: 20px;
          letter-spacing: 0.04em;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .cardo-nav-links, .cardo-nav-cta { display: none; }
          .cardo-hamburger { display: block; }
          .cardo-services-grid { grid-template-columns: repeat(2, 1fr); }
          .cardo-why-inner { grid-template-columns: 1fr; gap: 40px; }
        }
        @media (max-width: 600px) {
          .cardo-nav { padding: 0 20px; }
          .cardo-hero { padding: 80px 20px 60px; min-height: 70vh; }
          .cardo-section { padding: 60px 20px; }
          .cardo-why { padding: 60px 20px; }
          .cardo-why-cards { grid-template-columns: 1fr; }
          .cardo-services-grid { grid-template-columns: 1fr; }
          .cardo-stats { padding: 28px 20px; }
          .cardo-stat:not(:last-child)::after { display: none; }
          .cardo-cta { padding: 60px 20px; }
          .cardo-footer { padding: 20px; flex-direction: column; align-items: flex-start; }
        }
      `}</style>
      <BannerOne
          img={require('../assets/symptoms/cardiologyBanner.png')}
          title={"Interventional Cardiology Services"}
          subtitle={""}
        />

      <div className="cardo-root acc-root">
        {/* NAV */}
       

        {/* HERO */}
        {/* <section className="cardo-hero">
          
          <div className="cardo-hero-bg" />
          <div className="cardo-hero-grid-lines" />
          <div className="cardo-hero-content">
            <div className="cardo-hero-badge">Best Interventional Cardiologist in USA</div>
            <h1 className="cardo-hero-h1">
              World-Class <em>Interventional</em><br />Cardiology Services
            </h1>
            <p className="cardo-hero-sub">
              Trusted by over 40,000 patients. Our board-certified interventional cardiologists combine decades of expertise with the most advanced catheter-based technologies available.
            </p>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 32 }}>
              <PulseLine color="#2acb35" width={160} height={36} />
            </div>
            <div className="cardo-hero-btns">
              <button className="btn-primary">Schedule Appointment</button>
              <button className="btn-outline">Explore Services →</button>
            </div>
          </div>
        </section> */}

        {/* STATS */}
        {/* <div className="cardo-stats">
          {STATS.map(s => (
            <div className="cardo-stat" key={s.label}>
              <span className="cardo-stat-val"><Counter value={s.value} /></span>
              <span className="cardo-stat-lbl">{s.label}</span>
            </div>
          ))}
        </div> */}

        {/* SERVICES */}
        <section className="cardo-section">
          <p className="cardo-section-label">Our Services</p>
          <h2 className="cardo-section-h2">Comprehensive Interventional<br />Cardiology Services</h2>
          <p className="cardo-section-desc">
            Our interventional cardiology services are aimed at providing safer procedures, quicker recovery, and improved heart health. Our team employs minimally invasive approaches, modern imaging, and patient-centered planning to treat blocked arteries, valve issues, and vascular diseases with accuracy. Under the guidance of an experienced interventional cardiologist, patients receive expert diagnosis, clear treatment advice, and advanced procedure-based care designed around their health needs.
          </p>
          <div className="cardo-services-grid">
            {SERVICES.map((s, i) => <ServiceCard key={s.id} s={s} i={i} />)}
          </div>
        </section>

        {/* WHY */}
        <section className="cardo-why">
          <div className="cardo-why-inner">
            <div>
              <p className="cardo-section-label">Why Choose Us</p>
              <h2 className="cardo-section-h2">Trusted Expertise<br />and Compassionate Care</h2>
              <p className="cardo-section-desc" style={{ marginBottom: 0 }}>
                We provide our services aimed at serving patients in the USA and around the world. Having multiple access points to care and telehealth consultation services, patients can get professional advice without unnecessary delays. Our team is committed to making advanced heart care more accessible, understandable, and easily accessible.
              </p>
              <div style={{ marginTop: 32, display: "flex", gap: 12, flexWrap: "wrap" }}>
                {/* <button className="btn-primary" style={{ background: "linear-gradient(135deg,#2acb35,#4dde70)" }}>Meet Our Doctors</button> */}
                {/* <button style={{
                  background: "transparent",
                  border: "1.5px solid #e2e8f0",
                  color: "#0f172a",
                  padding: "14px 28px",
                  borderRadius: 40,
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: "'Hind', sans-serif",
                  transition: "all 0.2s",
                }}>View Credentials</button> */}
              </div>
            </div>
            <div className="cardo-why-cards">
              {WHY.map(w => (
                <div className="cardo-why-card" key={w.title}>
                  <div style={{ width: 70, height: 70, borderRadius: 14,  display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", transition: "background 0.3s", marginBottom: 15 }}>
          {w.image ? (
            <img src={w.image} alt={w.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <span style={{ fontSize: 24 }}>{w.icon}</span>
          )}
        </div>
                  <h4>{w.title}</h4>
                  <p>{w.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
      

        <section className="service-cta">
          <div className="service-container">
            <h2>Ready to Take the Next Step for Your Heart?</h2>
            <p>Call us today to talk about your interventional cardiology needs. We will be discussing your symptoms, your test reports, and the condition your heart is in, and help you receive care in a precise, safe, and patient-centered manner.</p>
            <div className="service-btns" style={{ justifyContent: 'center' }}>
              <button className="service-btn-primary" onClick={() => navigate('/consultations')}>Get Started</button>
            </div>
          </div>
        </section>

      
      </div>
    </>
  );
}